
export default function AboutContact(){
    return (
        <div>
            <img style={{marginTop:"130px", maxWidth:"200px"}} src={require("../component/images/logo-png.png")}></img>
            <h4>Updating soon ....</h4>
        </div>     
    )
}